import styled from "styled-components";
import { LabelStringColumn, PrimaryButton, ButtonText } from "@loanbossinc/component-library";

export const Avatar = styled.div`
  && {
    background: linear-gradient(212.88deg, #dfeffc 6.86%, rgba(249, 249, 249, 0) 116.99%);
    border-radius: 50%;
    height: 100px;
    margin: 1.5em 3.5em;
    width: 100px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const InputWrapper = styled.div`
  && {
    margin-top: 1em;
    width: 100%;
    min-width: 384px;
  }
`;

export const InputName = styled(LabelStringColumn)`
  && {
    color: #5f6368;
    margin-top: 1.5em;
  }
`;

export const Text = styled.p`
  && {
    margin: 0.5em 1.5em 1.5em 0;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #5f6368;
  }
`;

export const StyledPrimaryButton = styled(PrimaryButton)`
  && {
    background: #005aa9;
    margin-top: 3em;
    width: auto;
    font-size: 13px;
  }
`;

export const BackButton = styled(ButtonText)`
  && {
    display: flex;
    justify-content: flex-start;
    margin-top: 3.5em;
    .label {
      margin-left: 1em;
    }
  }
`;

export const ButtonBar = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 2em;
    width: ${props => (props.width ? props.width : "65%")};
  }
`;

export const DropDownBar = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 1em 1em 1em;
  }
`;

export const InputTypeAheadWrapper = styled.div`
  && {
    padding: 0 1em;
    width: 100%;
  }
`;

export const FileUploadWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`;

export const Container = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`;

export const Banner = styled.div`
  && {
    border-bottom: 1px solid #dadce0;
    border-radius: 8px 8px 0 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
`;

export const BannerItem = styled.div`
  && {
    display: flex;
    flex-direction: column;
    margin-left: 1.5em;
  }
`;

export const Title = styled.span`
  && {
    margin: 1.5em 1.5em 1.5em 0;
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 23px;
    color: #000000;
    text-align: left;
  }
`;

export const DealName = styled.span`
  && {
    margin: 1.5em 1.5em 0.5em 0;
    text-align: left;
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;

    color: #3f9ff4;
  }
`;

export const ReportName = styled.span`
  && {
    margin: 0.1em 1.8em 0.1em 0;
    text-align: left;
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #5f6368;
  }
`;

export const StepHeader = styled.span`
  && {
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 19px;
    text-align: center;
    color: #000000;
    margin: 3em 7em 1em 7em;
  }
`;

export const Card = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
  }
`;

export const WorkflowLinkWrapper = styled.button`
  && {
    align-items: center;
    background: #fafafa;
    border-radius: 8px;
    border: 1px solid #0f9ad6;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    height: 84px;
    justify-content: left;
    line-height: 19px;
    margin-top: 1em;
    padding: 1em;
    width: 384px;
  }
`;

export const WorkflowLinkIcon = styled.div`
  && {
    padding: 1em;
  }
`;

export const WorkflowLinkContent = styled.div`
  && {
    padding: 1em;
    text-align: left;
  }
`;
